/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const AuditReportsAodNotificationSettingsSchemaPolicyEnum = {
    NONE: "NONE",
    ORDER_END_ONLY: "ORDER_END_ONLY",
    ALWAYS: "ALWAYS"
} as const;

export type AuditReportsAodNotificationSettingsSchemaPolicyEnumKey = (typeof AuditReportsAodNotificationSettingsSchemaPolicyEnum)[keyof typeof AuditReportsAodNotificationSettingsSchemaPolicyEnum];

export type AuditReportsAodNotificationSettingsSchema = {
    /**
     * @type string
    */
    policy: AuditReportsAodNotificationSettingsSchemaPolicyEnumKey;
};